import LinkWithParams from "@/lib/common/LinkWithParams"
import { modelsPageModelNotFoundClick } from "@/lib/gtm"
import styled from "@emotion/styled"
import { Button } from "@mui/material"

const StyledLayout = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 8px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.26);
  border-radius: 8px;
  width: 100%;
  z-index: 10;
  ${(props) => props.theme.breakpoints.up("md")} {
    position: sticky;
    left: auto;
    margin-right: auto;
    bottom: 40px;
    width: 280px;
  }
`

export default function StickyButton(): React.ReactElement {
  return (
    <StyledLayout>
      <Button
        variant="contained"
        fullWidth
        LinkComponent={LinkWithParams}
        href="/contact-us"
        onClick={modelsPageModelNotFoundClick}
      >
        לא מצאת את הרכב שחיפשת?
      </Button>
    </StyledLayout>
  )
}
